import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

require('./battery-status.scss');
@Component({
  standalone: false,
  selector: 'app-battery-status',
  templateUrl: './battery-status.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatteryStatusComponent implements OnInit, OnChanges {
  @Input() batteryLevel: number;

  public icon: any;


  constructor() {
  }

  ngOnInit() {
    this.setIcon(this.batteryLevel)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.batteryLevel && !changes.batteryLevel.isFirstChange()) {
      this.setIcon(this.batteryLevel);
    }
  }

  private setIcon(batteryLevel) {
    this.icon = batteryLevel < 0.30 ? 'battery-low' : (batteryLevel < 0.75 ? 'battery-med' : 'battery-high');
  }

}
